import { trackSimpleEvent } from "../../shared/utils/reduxBeacon";
import { setQuantity } from "./configurations/actions";

const gaEventsMap = {
  ...trackSimpleEvent(setQuantity.typePrefix),
};

export default gaEventsMap;
